import Vue from 'vue';
//模块功能：产品详情
export default Vue.extend({
    name: "pro-detail",
    data: function () {
        return {};
    },
    mounted: function () {
    },
    methods: {
        /**
         * 功能：返回前一页面
         */
        toBack: function () {
            this.$router.go(-1);
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/iview-loader??ref--0-1!./src/sfc/product/pro-detail.vue
// module id = null
// module chunks = 